import Accordion from "./modules/accordion";
import Tabs from "./modules/tabs";
import MobileMenu from "./modules/mobile-menu";
import Animate from "./modules/animate";
import TableWrap from "./modules/table-wrap";

//Accordion
Accordion();

//Tabs
Tabs();

//Mobile menu
MobileMenu();

//Animate
Animate();

// TableWrap
TableWrap();
